export default __webpack_public_path__ + "static/media/FG_61.2e70598f.jpg";